import { NgModule } from '@angular/core';
import { HomePageRoutingModule } from './home-page.routing.module';
import { HomePageComponent } from './home-page.component';
import { SharedModule } from '../@shared/shared.module';
import { CommonModule } from '@angular/common';
import { FooterPageModule } from '../footer/footer-page.module';
import { SocialCarouselModule } from '../social-carousel/social-carousel.module';
import { OfferToggleModule } from '../offer-toggle/offer-toggle.module';
import { SwiperModule } from 'swiper/angular';
import { FooterV2Module } from '../footer-v2/footer-v2.module';
import { HomePageV2Component } from './home-page-v2/home-page-v2.component';
import { UtilitiesModule } from '../utilities/utilities.module';
import { SharedLayoutsModule } from '../@shared-layouts/shared-layouts.module';

@NgModule({
    declarations: [HomePageComponent, HomePageV2Component],
    imports: [
        HomePageRoutingModule,
        CommonModule,
        FooterPageModule,
        SharedModule,
        SocialCarouselModule,
        OfferToggleModule,
        SwiperModule,
        FooterV2Module,
        UtilitiesModule,
        SharedLayoutsModule,
    ],
})
export class HomePageModule {}
